(function () {
  'use strict';

  function hashText(value) {
    var hash = 2166136261;
    for (var index = 0; index < value.length; index += 1) {
      hash ^= value.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
  }

  function randomFromSeed(seed) {
    var state = seed >>> 0;
    return function () {
      state += 0x6d2b79f5;
      var value = state;
      value = Math.imul(value ^ (value >>> 15), value | 1);
      value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
      return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
    };
  }

  function storeDayKey() {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Los_Angeles',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date());
      var values = {};
      parts.forEach(function (part) { values[part.type] = part.value; });
      return [values.year, values.month, values.day].join('-');
    } catch (error) {
      return new Date().toISOString().slice(0, 10);
    }
  }

  function chooseThree(collections, sectionId) {
    var random = randomFromSeed(hashText(storeDayKey() + ':' + sectionId));
    var candidates = collections.slice();
    var selected = [];
    while (selected.length < 3 && candidates.length) {
      var index = Math.floor(random() * candidates.length);
      selected.push(candidates.splice(index, 1)[0]);
    }
    return selected;
  }

  function imageUrl(url, width) {
    if (!url) return '';
    if (/([?&])width=\d+/.test(url)) {
      return url.replace(/([?&])width=\d+/, '$1width=' + width);
    }
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function renderCollectionCard(card, collection, cardIndex) {
    if (!card || !collection) return;
    var link = card.querySelector('.occasion-collection-card__surface');
    var image = card.querySelector('.occasion-collection-card__image img');
    var title = card.querySelector('[data-occasion-collection-title]');
    var kicker = card.querySelector('[data-occasion-collection-kicker]');
    var caption = card.querySelector('[data-occasion-collection-caption]');
    if (!link || !image || !title) return;

    link.href = collection.url || ('/collections/' + collection.handle);
    link.removeAttribute('aria-disabled');
    link.removeAttribute('tabindex');
    link.setAttribute('aria-label', 'Shop ' + collection.title);
    card.classList.remove('is-disabled');
    card.dataset.collectionHandle = collection.handle || '';

    image.src = imageUrl(collection.image_url, cardIndex === 0 ? 1600 : 1000);
    image.srcset = [
      imageUrl(collection.image_url, 480) + ' 480w',
      imageUrl(collection.image_url, 800) + ' 800w',
      imageUrl(collection.image_url, 1200) + ' 1200w',
      imageUrl(collection.image_url, 1600) + ' 1600w'
    ].join(', ');
    image.sizes = cardIndex === 0
      ? '(min-width: 901px) 66vw, 100vw'
      : '(min-width: 901px) 32vw, (min-width: 621px) 50vw, 100vw';
    image.alt = collection.image_alt || collection.title;
    image.width = Number(collection.image_width) || 1200;
    image.height = Number(collection.image_height) || 1200;
    title.textContent = collection.title;
    if (kicker) kicker.textContent = cardIndex === 0 ? '01 / Today’s lead' : '0' + (cardIndex + 1) + ' / Today’s edit';
    if (caption) caption.textContent = cardIndex === 0 ? 'The first route into today’s celebration edit.' : 'Another way into today’s celebration edit.';
  }

  function initializeCollections(root) {
    if (!root || root.dataset.occasionCollectionsReady === 'true') return;
    var poolNode = root.querySelector('[data-occasion-collection-pool]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-occasion-collection-card]'));
    if (!poolNode || cards.length !== 3) return;

    var collections;
    try {
      collections = JSON.parse(poolNode.textContent || '[]');
    } catch (error) {
      return;
    }

    if (!Array.isArray(collections) || collections.length < 3) {
      root.dataset.occasionCollectionState = 'fallback';
      return;
    }

    chooseThree(collections, root.dataset.sectionId || 'home').forEach(function (collection, index) {
      renderCollectionCard(cards[index], collection, index);
    });
    root.dataset.occasionCollectionsReady = 'true';
    root.dataset.occasionCollectionState = 'daily';
    root.dataset.occasionCollectionDay = storeDayKey();
  }

  function initializeFaq(root) {
    var list = root.querySelector('[data-occasion-faq]');
    if (!list || list.dataset.occasionFaqReady === 'true') return;
    var items = Array.prototype.slice.call(list.querySelectorAll('details'));
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (otherItem) {
          if (otherItem !== item) otherItem.open = false;
        });
      });
    });
    list.dataset.occasionFaqReady = 'true';
  }

  function initializeImageFallbacks(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-occasion-image]'), function (image) {
      if (image.dataset.occasionImageReady === 'true') return;
      image.addEventListener('error', function () {
        image.classList.add('is-fallback');
        var surface = image.closest('figure, .occasion-collection-card__image, .occasion-journal__image');
        if (surface) surface.classList.add('has-image-error');
      });
      image.dataset.occasionImageReady = 'true';
    });
  }

  function initialize(root) {
    initializeCollections(root);
    initializeFaq(root);
    initializeImageFallbacks(root);
  }

  function initializeAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-occasion-home]'), initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
})();
